// src/components/AtomicGraphic.js

import React from 'react';

// Simple atomic SVG graphic

const AtomicGraphic = ({ showComingSoon = true, label = 'COMING SOON' }) => (
  <div className="atomic-graphic" style={{ position: 'relative', display: 'flex', justifyContent: 'center', margin: '2em 0' }}>
    <svg
      width="180" height="180" viewBox="0 0 180 180" fill="none" xmlns="http://www.w3.org/2000/svg"
      style={{ animation: 'spin 3s linear infinite' }}
      aria-hidden="true"
    >
      <circle cx="90" cy="90" r="18" fill="#ff9800" stroke="#333" strokeWidth="2" />
      <ellipse cx="90" cy="90" rx="60" ry="24" stroke="#2196f3" strokeWidth="2" fill="none" />
      <ellipse cx="90" cy="90" rx="24" ry="60" stroke="#4caf50" strokeWidth="2" fill="none" />
      <ellipse cx="90" cy="90" rx="48" ry="48" stroke="#e91e63" strokeWidth="2" fill="none" />
      <circle cx="90" cy="30" r="6" fill="#2196f3" stroke="#333" strokeWidth="1" />
      <circle cx="150" cy="90" r="6" fill="#4caf50" stroke="#333" strokeWidth="1" />
      <circle cx="90" cy="150" r="6" fill="#e91e63" stroke="#333" strokeWidth="1" />
      <circle cx="30" cy="90" r="6" fill="#ff9800" stroke="#333" strokeWidth="1" />
    </svg>

    {/* COMING SOON badge */}
    {showComingSoon && (
      <div
        style={{
          position: 'absolute',
          bottom: '-8px',
          left: '50%',
          transform: 'translateX(-50%)',
          background: 'linear-gradient(90deg, rgba(0,0,0,0.55), rgba(0,0,0,0.35))',
          color: '#ffd700',
          padding: '6px 12px',
          borderRadius: 8,
          fontWeight: 700,
          letterSpacing: '2px',
          boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
          fontFamily: 'Arial, sans-serif',
          fontSize: 12,
          pointerEvents: 'none'
        }}
        aria-hidden="true"
      >
        {label}
      </div>
    )}

    <style>{`
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `}</style>
  </div>
);

export default AtomicGraphic;